import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qfhkgjanvcdgickqtdkm.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFmaGtnamFudmNkZ2lja3F0ZGttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYxNDY4NDQsImV4cCI6MjA4MTcyMjg0NH0.ezQmhSkn_NwFoJbhv7xFViTW_osvTWCABalwcRxCIZM';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);